<template lang="pug">
  .wrapper-resource-home-block(v-if="family")
    h3.title {{family.name}}
    p.description(v-html="family.description")
    .row.recurso-list
      .col-md-3.col-sm-6.col-xs-12.recurso(
        v-for="resource in resources"
        v-if="resources.length"
      )
        //- router-link.link-home-to-resource(
        //-   :to="{name: 'ResourcesEntrada', params: {slug: resource.slug}}"
        //-   :class="{'private-unlocked': resource.private}"
        //-   v-if="token || !resource.private"
        //- )
        div(v-if="token || !resource.private")
          img(v-if="resource.image" :src="resource.image")
          p {{resource.title}}
        //- .link-home-to-resource(
        //-   :to="{name: 'ResourcesEntrada', params: {slug: resource.slug}}"
        //-   v-if="!token && resource.private"
        //- )
        div(v-if="!token && resource.private")
          img(v-if="resource.image" :src="resource.image")
          p
            span {{resource.title}}
            em.private (Sólo para usuarios registrados)
    .text-center
      router-link(:to="{name:'ResourcesType', params: {slug: family.slug}}")
        button.button-yellow-round.resource-family-link Ver {{family.name}}
</template>

<script type="text/javascript">
import { mapState } from 'vuex'

export default {
  name: "ResourceHomeBlock",
  props: ["family", "plan"],
  computed: mapState([
    "token",
    "context",
  ]),
  data() {
    return {
      resources: [],
    }
  },
  async created() {
    let filters = {family: this.family.slug, plan: this.plan}

    const resourcesResponse = await this.$wagtail.getResources(4, filters)
    const data = resourcesResponse.data
    this.resources = data.results
  },
  methods: {
    isVisible(resource) {
      switch (this.plan) {
        case "basic":
          return resource.on_basic
        case "estandar":
          return resource.on_estandar
        case "premium":
          return resource.on_premium
      }
      return false
    },
  }
}
</script>

<style scoped lang="scss">
em.private {
  font-size: 0.8rem;
  font-weight: 700;
  width: 100%;
  display: block;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceHomeBlock.vue